var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-v2',{attrs:{"label":_vm.label,"hint":_vm.hint,"error":_vm.error,"disabled":_vm.disabled}},[_c('phone-input',_vm._g(_vm._b({attrs:{"v2":"","show-flag-in-selection":false,"only-countries":_vm.countryIds,"enable-search-country":"","error":!!_vm.error,"disabled":_vm.disabled}},'phone-input',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }